var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('my-app',{attrs:{"auth-rules":"supervisor|admin|general"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var mode = ref.mode;
var admin = ref.admin;
return [_c('v-container',{attrs:{"fluid":"","data-cy":"home.homePage.container"}},[(admin)?_c('tenant-for-admin'):_c('tenant'),(mode === 'mobile')?_c('scroll-to-top-button'):_vm._e()],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }